import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import MissionSection from './components/MissionSection';
import VideoSection from './components/VideoSection';
import CounselingSection from './components/CounselingSection';
import EducationSection from './components/EducationSection';
import NewsSection from './components/NewsSection';
import DonationSection from './components/DonationSection';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '대한효복지센터',
  url: siteUrl,
  logo: `${siteUrl}/vite.svg`,
  description: '대한효복지센터는 활동지원사와 장애인이 함께 성장하는 복지 생태계를 만듭니다. 전문 상담, 역량강화 교육, 장애인 일상 지원, 후원 참여까지 따뜻한 연대의 플랫폼입니다.',
  address: {
    '@type': 'PostalAddress',
    addressRegion: '서울특별시 마포구',
    addressCountry: 'KR',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    availableLanguage: '한국어',
  },
  sameAs: [
    'http://pf.kakao.com/_shtEX',
  ],
};

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: '대한효복지센터',
  url: siteUrl,
  description: '활동지원사 교육·상담·후원을 제공하는 장애인 복지 전문 기관입니다.',
  address: {
    '@type': 'PostalAddress',
    addressRegion: '서울특별시 마포구',
    addressCountry: 'KR',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 37.5563,
    longitude: 126.9218,
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '18:00',
    },
  ],
  priceRange: '무료',
};

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '대한효복지센터',
  url: siteUrl,
  description: '활동지원사와 장애인이 함께 성장하는 따뜻한 복지 생태계',
  inLanguage: 'ko',
  publisher: {
    '@type': 'Organization',
    name: '대한효복지센터',
  },
};

export default function HomePage() {
  return (
    <div className="font-sans min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <MissionSection />
        <VideoSection />
        <CounselingSection />
        <EducationSection />
        <NewsSection />
        <DonationSection />
      </main>
      <Footer />
    </div>
  );
}
